import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { waukeganConfig } from "./data";

export default function WaukeganPage() {
  return <CityPageTemplate config={waukeganConfig} />;
}